import urls from '@app/plugins/urls'
import { kintoneHealthModule } from '@app/store'
import { reportKintoneOutageRedirect } from '@app/utils/kintoneOutageReport'

export default async function ({
  route,
  redirect,
}: {
  route: { path: string }
  redirect: any
}) {
  await kintoneHealthModule.check()

  if (kintoneHealthModule.status === 'ng') {
    kintoneHealthModule.setBlockedFrom(route.path)
    reportKintoneOutageRedirect(route.path)
    redirect(urls.kintoneOutage)
  }
}
